module.exports = __webpack_public_path__ + "static/media/why-fachausweis.a3f483b0.jpg";